import "./home.scss";
import { motion } from "framer-motion";

const textVariants = {
  initial: {
    x: -500,
    opacity: 0,
  },
  animate: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 1,
      staggerChildren: 0.1,
    },
  },
  scrollButton: {
    opacity: 0,
    y: 10,
    transition: {
      duration: 2,
      repeat: Infinity,
    },
  },
};
const sliderVariants = {
  initial: {
    x: 0,
  },
  animate: {
    x: "-220%",
    transition: {
      repeat: Infinity,
      repeatType: "mirror",
      duration: 20,
    },
  },
};

const Home = () => {
  return (
    <div className="home">
      <div className="wrapper">
        <motion.div
          className="textContainer"
          variants={textVariants}
          initial="initial"
          animate="animate"
        >
          <motion.h2 variants={textVariants}>RÉNOMETAL : </motion.h2>
          <motion.h1 variants={textVariants}>
            Expert Amiante Site Occupé Rhône-Alpes
          </motion.h1>
          <motion.div variants={textVariants} className="buttons">
            <motion.a href="#Réalisation" className="desktop-only" variants={textVariants}>
              Nos réalisations
            </motion.a>
            <motion.a href="#Contact" variants={textVariants}>
              Contact
            </motion.a>
          </motion.div>
          <motion.img
            variants={textVariants}
            animate="scrollButton"
            src="/scroll.png"
            alt=""
          />
        </motion.div>
      </div>
      <motion.div
        className="slidingTextContainer"
        variants={sliderVariants}
        initial="initial"
        animate="animate"
      >
        Rénovation Batiment Industriel
      </motion.div>
      <div className="imageContainer">
        <img src="/home 2.png" alt="" />
      </div>
    </div>
  );
};

export default Home;
